export default __webpack_public_path__ + "static/media/skyline.54d69e21.png";